import React from 'react';

function LoadingSpinner() {
  return (
    <div className="flex flex-col items-center">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      <p className="mt-4 text-gray-700">Loading...</p>
    </div>
  );
}

export default LoadingSpinner;